import React from "react"

import AvatarAndInfo from "~components/shared/avatar-and-info"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/test-ids"
import type {
    OutfitterMinimalFieldsFragment,
    PublicOutfitterFieldsFragment,
} from "~graphql/generated/graphql"

interface Props {
    readonly outfitter:
        | PublicOutfitterFieldsFragment
        | OutfitterMinimalFieldsFragment
}

export default function OwnerSection({ outfitter }: Props) {
    const owner = outfitter.owner
    const fullName = `${owner.first_name} ${owner.last_name}`

    return (
        <AvatarAndInfo
            avatar={owner.avatar_url ?? ""}
            name={fullName}
            title={fullName}
            subtitle={COPY.OWNER}
            testId={TEST_IDS.OWNER_SECTION}
        />
    )
}
